import React, { Component } from "react";
import logo from "../../assets/images/SFF_logo_2024.svg";
import bkg from "../../assets/images/frame-bkg.svg";
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../redux/bindActionCretor";

import service from "../../services";
import Loader from "../../component/loader";

import { Link } from "react-router-dom";

import ShowPasswordIcon from "./../../icons/ShowPassIcon";
import ViewIcon from "./../../icons/viewIcon";
import ErrorPopUp from "../../component/errorPopUp";

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActCreators, dispatch);
};

let sub;

class ScreeningSignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPass: false,
      pin: "",
      password: "",
      scannerDetails: []
    };
    this.apiserve = new service();
  }

  componentDidMount = () => {
    if (this.props.location.search) {
      let paramsData = this.apiserve.decrypt(this.props.location.search.replace("?data=", ""));
      paramsData.then((val) => this.setState({ scannerDetails: val }));
    }
  };


  Showpassword = () => {
    this.setState({
      showPass: !this.state.showPass
    });
  };

  onInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  };

  submitFn = (e) => {
    e.preventDefault();
    const { scannerDetails } = this.state;
    const data = {
      pin: this.state.pin,
      password: this.state.password,
      screenId: scannerDetails.film,
    };
    this.apiserve.sendevent("adminPrivateScreening|screenerSignup", data);
    this.setState({
      loaderFlag: true
    });

  };

  clearFn = () => this.setState({pin:'',password:''})

  errorMsgPopup = () => {
    this.setState({
      errorPopup: false
    });
  };


  render() {
    
    return (
      <>
        <div className="container">
          <header>
            <div className="logo">
              <img src={logo} />
            </div>
            <div className="title">
              <h1>SUNDANCE FILM FESTIVAL - CMS</h1>
            </div>
            <div className="support_link">
              <a href="mailto:sff@sundance.org" target="_blank">Contact Support</a>
            </div>
          </header>
          <div className="dashboard_wrapper">
            <div className="sundance_wrapper w_100" style={{ height: "465px" }}>

              {/* For Background Images */}
              <div className="background">
              <img src={'https://d2wsrejhnxatgp.cloudfront.net/assest/common/CMS_Background.png'} />
              </div>
              {/* // For Background Images */}

              {/* Box Design Start here */}
              <div className="box_wrapper signIn_box_Wrapper">
                <h2>Screener Sign In</h2>
                <form onSubmit={() => this.submitFn()}>
                  <div>
                    <label>PIN</label>
                    <input
                      type="pin"
                      name="pin"
                      id="pin"
                      value={this.state.pin}
                      onChange={this.onInputChange}
                    />
                  </div>
                  <div>
                    <label>Password</label>
                    <div className="relative">
                      <input
                        type={this.state.showPass ? "text" : "password"}
                        name="password"
                        id="password"
                        value={this.state.password}
                        onChange={this.onInputChange} />
                      <span className="eye_icon" onClick={this.Showpassword}>
                                                            {
                                                              this.state.showPass ? <ShowPasswordIcon /> : <ViewIcon />
                                                            }
                                                        </span>
                    </div>
                  </div>

                  <div>
                    <button
                      className="grayBTN"
                      type="button"
                      onClick={() => this.clearFn()}
                    >Clear
                    </button>
                    <button
                      type="submit"

                      onClick={(e) => this.submitFn(e)}
                      className="orangeBTN"
                    >Submit
                    </button>
                  </div>
                </form>
              </div>
              {/* Box Design End's here */}

            </div>
            {/* Box Design Start here */}
          </div>
          {this.state.errorPopup ?
            <ErrorPopUp
              errorMsg={this.state.errorMsg}
              errorMsgPopup={this.errorMsgPopup}
            />
            : ""
          }
        </div>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ScreeningSignIn);